export type WaitlistResult =
  | { status: 'ok' }
  | { status: 'failed' }
  | { status: 'invalidemail' };

export async function subscribeToWaitlist(
  waitlistId: number,
  email: string,
  eventId: number | string,
): Promise<WaitlistResult> {
  const params = new URLSearchParams({
    waitlist: waitlistId.toString(),
    email,
    event_id: eventId.toString(),
    tripwire: 'spam-bot-tripwire',
  });

  try {
    const response = await fetch(`/of2/public_services/subscribe_to_waitlist?${params.toString()}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    const data = await response.json();
    return data as WaitlistResult;
  } catch (error) {
    console.error('Error subscribing to waitlist:', error);
    return { status: 'failed' };
  }
}
